import {useState} from "react";
import PurchaseModal from "@/Pages/Dashboard/Purchase/PurchaseModal";

type MobileMenuCreditsProps = {
    credits: number,
    prices: Record<string, number>,
    onBuyClick?: () => void,
}

function formatBalance(minutes: number): string {
    const totalMinutes = Math.max(0, Math.ceil(minutes));
    const hours = Math.floor(totalMinutes / 60);
    const remainingMinutes = totalMinutes % 60;
    if (hours === 0) {
        return `${remainingMinutes}m`;
    }
    return remainingMinutes === 0 ? `${hours}h` : `${hours}h ${remainingMinutes}m`;
}

export default function MobileMenuCredits({credits, prices, onBuyClick}: MobileMenuCreditsProps) {
    const [showPurchaseModal, setShowPurchaseModal] = useState(false);

    return (
        <div>
            <p className="text-gray-500 dark:text-gray-400">Processing time remaining</p>
            <p className="mt-0.5 text-base font-semibold tabular-nums text-gray-900 dark:text-gray-100">
                {formatBalance(credits)}
            </p>
            <button
                type="button"
                onClick={() => {
                    onBuyClick?.();
                    setShowPurchaseModal(true);
                }}
                className="mt-3 w-full rounded-md border border-gray-200 bg-white py-1.5 text-sm font-medium text-blue-600 transition-colors hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 dark:border-gray-600 dark:bg-gray-800 dark:text-blue-400 dark:hover:bg-gray-700">
                Buy credits
            </button>
            <PurchaseModal
                show={showPurchaseModal}
                onClose={() => setShowPurchaseModal(false)}
                prices={prices}
            />
        </div>
    );
}
